//自定义指令
/**
 *
 * @param Vue
 */

const init=function(Vue){
  Vue.directive('loadmore', {
    bind (el, binding) {
      const selectWrap = el.querySelector('.el-table__body-wrapper')
      selectWrap.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop <= this.clientHeight) {
            binding.value()
          }
        }
      )
    }
  })
  Vue.directive('height', {
    inserted(el, binding) {
      setHeight(el, binding.value)
      window.addEventListener('resize', () => setHeight(el, binding.value))
      function setHeight(el, bottom) {
        let node =el
        let h = 0
        while (node  !== document.body&&node!=null) {
          h += node.offsetTop
          node = node.offsetParent
        }
        let height
        if (document.documentElement.clientHeight < h + 300) {
          height = 300 - bottom
        } else {
          height = (document.documentElement.clientHeight - h - bottom)
        }
        console.log(height)
        el.style.height = height + 'px'
      }
    }
  })

  Vue.directive('tb-height',{
    inserted(el, binding) {
      setHeightElTable(el, binding.value.bottom,binding.value.self)
      window.addEventListener('resize', () => setHeightElTable(el, binding.value.bottom,binding.value.self))
      function setHeightElTable(el, bottom=40,self) {
        self.$nextTick(()=>{
          let node =el
          let h = 0
          while (node !== document.body&&node!=null) {
            h +=node.offsetTop
            node = node.offsetParent
          }
          if (document.documentElement.clientHeight < h + 300) {
            self.height = 300-bottom
          } else {
            self.height = document.documentElement.clientHeight - h - bottom
          }
        })
      }
    }
  })
  Vue.directive('text-rows',{
    inserted(el,binding){
      console.log(binding.value)
      el.style="display: -webkit-box;" +
        "-webkit-box-orient: vertical;" +
        "overflow: hidden;" +
        `-webkit-line-clamp: ${binding.value?binding.value:1};`
    }
  })
  Vue.directive('style',{
    inserted(el,binding){
      if(binding.value.flag){
        el.style=binding.value.style
      }
    }
  })
}

export default init



// WEBPACK FOOTER //
// ./src/directive.js